var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainview"}},[_c('el-main',[_c('div',{attrs:{"id":"container"}})]),_c('Play',{attrs:{"floor":_vm.obj.floor_name,"wall":_vm.obj.wall_name,"speed":6000}}),_c('Function',{attrs:{"obj":_vm.obj,"vip":_vm.vip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }